export default __webpack_public_path__ + "static/tablocation02-0d5a9b93b55a4b6f6645a6225a2331e0.png";